import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=2a9e6020&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"
import style0 from "./contact.vue?vue&type=style&index=0&id=2a9e6020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9e6020",
  null
  
)

export default component.exports